<!-- 热门模拟交易榜单 -->
<template>
  <div class="mnjybdMore" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div
      class="mnjybdMore-nav"
      :style="`background: url('${
        active == 2 ? bgurl2 : active == 3 ? bgurl3 : bgurl1
      }')no-repeat top right; background-size: 100% 100%;`"
    >
      <van-nav-bar title="热门模拟交易榜单" left-arrow @click-left="onClickLeft" />
    </div>

    <div class="content">
      <!-- swipeable animated -->
      <van-tabs v-model="active">
        <van-tab v-for="(item, index) in bdList" :title="item.title" :key="index">
          <p class="desc">{{ item.desc }}</p>

          <div class="title_ul" v-show="active < 2">
            <li>模拟交易名称</li>
            <li>今日收益</li>
            <li>创建后收益</li>
          </div>

          <div class="title_ul" v-show="active == 2">
            <li>模拟交易名称</li>
            <li>创建后收益</li>
            <li>最大回撤</li>
          </div>

          <div class="title_ul" v-show="active == 3">
            <li>模拟交易名称</li>
            <li>创建后收益</li>
            <li>交易胜率</li>
          </div>

          <ul class="bdList">
            <li
              class="bdList_li"
              v-for="(item3, index3) in todayRisk"
              v-show="active === 0"
              :key="item3.capitalId + 0"
              @click="goMnDetail(item3)"
            >
              <div class="left">
                <p class="top">
                  <span class="index" v-if="index3 === 0" style="background: #f46363">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 1" style="background: #f90">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 2" style="background: #ffd953">{{
                    index3 + 1
                  }}</span>

                  <span class="index" v-else>{{ index3 + 1 }}</span>
                  <span class="name">{{ item3.name }}</span>
                </p>
              </div>

              <div class="center">
                <span :class="[judgeColor(item3.todayRisk)]">
                  {{ toFixedNum(item3.todayRisk * 100, 2, '%') }}
                </span>
              </div>

              <div class="right">
                <p class="zf" :class="[judgeColor(item3.totalRisk)]">
                  {{ toFixedNum(item3.totalRisk * 100, 2, '%') }}
                </p>
              </div>
            </li>

            <li
              class="bdList_li"
              v-for="(item3, index3) in totalRisk"
              v-show="active === 1"
              :key="item3.capitalId + 1"
              @click="goMnDetail(item3)"
            >
              <div class="left">
                <p class="top">
                  <span class="index" v-if="index3 === 0" style="background: #f46363">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 1" style="background: #f90">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 2" style="background: #ffd953">{{
                    index3 + 1
                  }}</span>

                  <span class="index" v-else>{{ index3 + 1 }}</span>
                  <span class="name">{{ item3.name }}</span>
                </p>
              </div>

              <div class="center">
                <span :class="[judgeColor(item3.todayRisk)]">
                  {{ toFixedNum(item3.todayRisk * 100, 2, '%') }}
                </span>
              </div>

              <div class="right">
                <p class="zf" :class="[judgeColor(item3.totalRisk)]">
                  {{ toFixedNum(item3.totalRisk * 100, 2, '%') }}
                </p>
              </div>
            </li>

            <li
              class="bdList_li"
              v-for="(item3, index3) in maxRetreatRate"
              v-show="active === 2"
              :key="item3.capitalId + 2"
              @click="goMnDetail(item3)"
            >
              <div class="left">
                <p class="top">
                  <span class="index" v-if="index3 === 0" style="background: #f46363">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 1" style="background: #f90">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 2" style="background: #ffd953">{{
                    index3 + 1
                  }}</span>

                  <span class="index" v-else>{{ index3 + 1 }}</span>
                  <span class="name">{{ item3.name }}</span>
                </p>
              </div>

              <div class="center">
                <span :class="[judgeColor(item3.totalRisk)]">
                  {{ toFixedNum(item3.totalRisk * 100, 2, '%') }}
                </span>
              </div>

              <div class="right">
                <p class="zf">
                  {{ toFixedNum(item3.maxRetreatRate * 100, 2, '%') }}
                </p>
              </div>
            </li>

            <li
              class="bdList_li"
              v-for="(item3, index3) in successRate"
              v-show="active === 3"
              :key="item3.capitalId + 3"
              @click="goMnDetail(item3)"
            >
              <div class="left">
                <p class="top">
                  <span class="index" v-if="index3 === 0" style="background: #f46363">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 1" style="background: #f90">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 2" style="background: #ffd953">{{
                    index3 + 1
                  }}</span>

                  <span class="index" v-else>{{ index3 + 1 }}</span>
                  <span class="name">{{ item3.name }}</span>
                </p>
              </div>

              <div class="center">
                <span :class="[judgeColor(item3.totalRisk)]">
                  {{ toFixedNum(item3.totalRisk * 100, 2, '%') }}
                </span>
              </div>

              <div class="right">
                <p class="zf">
                  {{ toFixedNum(item3.successRate * 100, 2, '%') }}
                </p>
              </div>
            </li>
          </ul>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { getHotMokpanelList } from '@/api/index.js';
import { judgeColor, toFixedNum,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';

export default {
  name: 'MnjybdMore',
  mixins: [mixin],
  props: [],

  data() {
    return {
      active: 0,
      bgurl1: require('../../assets/image/syb2x.png'),
      bgurl2: require('../../assets/image/wjb2x.png'),
      bgurl3: require('../../assets/image/slb2x.png'),
      bdList: [
        {
          id: 0,
          title: '今日收益榜',
          desc: '按模拟交易今日收益从大到小排序'
        },
        {
          id: 1,
          title: '创建后收益榜',
          desc: '按模拟交易创建后收益从大到小排序'
        },
        {
          id: 2,
          title: '稳健榜',
          desc: '按模拟交易最大回撤从小到大排序'
        },
        {
          id: 2,
          title: '胜率榜',
          desc: '按模拟交易历史交易胜率从大到小排序'
        }
      ],
      todayRisk: [], //今日收益
      totalRisk: [], //创建后收益
      successRate: [], //胜率榜
      maxRetreatRate: [], //稳健榜
      interval: null,
      isVip: false
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    this.getHotMokpanelListFun();

    this.interval = setInterval(() => {
      this.getHotMokpanelListFun();
    }, 1000 * 60);
  },
  methods: {
    judgeColor,
    toFixedNum,
    compareVersions,

    onClickLeft: function () {
      this.$router.go(-1);
    },

    getHotMokpanelListFun: function () {
      var params = {};
      return getHotMokpanelList(params)
        .then((res) => {
          this.todayRisk = res.data.todayRisk;
          this.totalRisk = res.data.totalRisk;
          this.successRate = res.data.successRate;
          this.maxRetreatRate = res.data.maxRetreatRate;
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    // 跳转模拟详情
    goMnDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0704'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/mnDetail?DZHSPECIAL=4325641&type=hot&zj_id=' + item.capitalId;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>
<style lang="less" scoped>
.mnjybdMore {
  .mnjybdMore-nav {
    ::v-deep {
      .van-hairline--bottom::after {
        display: none;
      }
      .van-nav-bar {
        padding-top: 40px;
        background: none;
      }
      .van-nav-bar__left,
      .van-nav-bar__right {
        padding: 0 16px;
      }

      .van-icon,
      .van-nav-bar__title {
        color: #333;
      }
    }
  }
  .content {
    ::v-deep {
      .van-tabs__wrap {
        height: auto;
        padding: 0 12px;
      }
      .van-tabs__nav {
        background: none;
      }
      .van-tabs__nav--line {
        padding-bottom: 12px;
      }
      .van-tab {
        border-radius: 6px;
        border: 1px solid #f5f6f9;
        color: #999;
        font-size: 13px;
        padding: 4px 0;
        height: 26px;
        line-height: 26px;
        flex: auto;
        margin: 0 4px;
      }
      .van-tabs__line {
        display: none;
      }
      .van-tab--active {
        background: #eaf0fe;
        color: #286df7;
      }
    }
    .desc {
      color: #ccc;
      font-size: 12px;
      padding: 0 16px;
    }

    .title_ul {
      display: flex;
      align-items: center;
      margin-top: 13px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      padding: 0 16px 5px;

      li {
        flex-shrink: 0;
        list-style: none;
        color: #666;
        font-size: 10px;
        &:nth-child(1) {
          width: 47.3%;
        }
        &:nth-child(2) {
          width: 28.3%;
        }
        &:nth-child(3) {
          width: 28.3%;
          text-align: right;
          padding-right: 16px;
        }
      }
    }

    .bdList {
      margin-top: 10px;
      overflow-y: auto;
      height: calc(100vh - 185px);
      .bdList_li {
        padding: 10px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          width: 47.3%;
          flex-shrink: 0;
          .top {
            display: flex;
            align-items: center;
            .index {
              border-radius: 4px;
              background: #999;
              width: 16px;
              height: 16px;
              text-align: center;
              line-height: 16px;
              color: #fff;
              font-size: 10px;
              font-weight: 600;
              display: inline-block;
              flex-shrink: 0;
            }
            .name {
              color: #555;
              font-size: 14px;
              font-weight: 600;
              margin-left: 4px;
            }
          }
        }
        .center {
          width: 24.3%;
          flex-shrink: 0;
        }
        .right {
          width: 28.3%;
          flex-shrink: 0;
          text-align: right;
          .zf {
            font-size: 14px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  background: #1a1c26;
  ::v-deep {
    .van-icon,
    .van-nav-bar__title {
      color: #fff !important;
    }
  }
  .content {
    ::v-deep {
      .van-tab {
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: #999;
      }
      .van-tab--active {
        border: 1px solid #1f2f4f;
        background: #1f2f4f;
        color: #3b85fe;
      }
    }
    .desc {
      color: #aab9d1;
    }
    .title_ul {
      li {
        color: #6b7687;
      }
    }
    .bdList {
      .bdList_li {
        .left {
          .top {
            .name {
              color: #aab9d1;
            }
          }
        }
        .zf {
          color: #aab9d1;
        }
      }
    }
  }
}
</style>
